export default {
    methods: {
        getLocalisedText() {
            switch (this.$store.state.language) {
                case "sv":
                default:
                    return {
                        allDone: "Tack! Nu är alla uppgifter klara.",
                    };
            }
        }
    }
}
